export const CSS_PROPERTY_CONSTANTS = {
  BACKGROUND_COLOR: 'BACKGROUND_COLOR',
  TEXT_COLOR: 'TEXT',
  BACKGROUND_IMAGE: 'BACKGROUND_IMAGE',
  HEIGHT: 'HEIGHT',
};
